/* eslint-disable */

function headerPin() {

    const headerEl = document.querySelector(".site-header");
    const careersMenuEl = document.querySelector(".careersMenu--lg");
    const careersMenuElSm = document.querySelector(".careersMenu--sm");
    const observer = new IntersectionObserver(
        ([e]) => {
            const isHeaderPinned = e.intersectionRatio < 1;
            headerEl.classList.toggle("is-pinned", isHeaderPinned);
            if(careersMenuEl && careersMenuElSm) {
                careersMenuEl.classList.toggle("is-pinned", isHeaderPinned);
                careersMenuElSm.classList.toggle("is-pinned", isHeaderPinned);
            }
        },
        { threshold: [1] }
    );

    observer.observe(headerEl);

}

function mainNav() {

    /**
     * File navigation.js.
     *
     * Handles toggling the navigation menu for small screens and enables TAB key
     * navigation support for dropdown menus.
     */
    let i, len;

    const container = document.getElementById('site-navigation');
    if (!container) {
        return;
    }

    const mainMenu = document.getElementById('menu-main-menu');

    if ('undefined' === typeof mainMenu) {
        return;
    }


    // toggle click on menu items with class .headerMenu__itemLink, and add class .open
    const menuItems = document.querySelectorAll('button.headerMenu__itemLink');
    menuItems.forEach((item) => {

        // add aria-hidden="true" to each .megaMenuWrapper div that is a sibling of item
        const megaMenuWrapper = item.parentNode.querySelector('.megaMenuWrapper');
        if (megaMenuWrapper) {

            // get item's data-menu-title attribute and prepend it in the siblings megaMenuWrapper in an h3
            const menuTitle = item.getAttribute('data-menu-title');
            const menuTitleEl = document.createElement('h3');
            menuTitleEl.classList.add('megaMenuWrapper__title');
            menuTitleEl.textContent = menuTitle;
            megaMenuWrapper.prepend(menuTitleEl);

            // give unique id to each .megaMenuWrapper div that is a sibling of item
            const megaMenuWrapperId = 'megaMenuWrapper-' + item.parentNode.id;
            megaMenuWrapper.setAttribute('id', megaMenuWrapperId);

            // add aria attributes to each item
            item.setAttribute('aria-expanded', 'false');
            item.setAttribute('aria-haspopup', 'true');
            item.setAttribute('aria-controls', megaMenuWrapperId);

            megaMenuWrapper.setAttribute('aria-hidden', 'true');
        }

        item.addEventListener('click', (event) => {
            
            const clickedItem = event.currentTarget;

            menuItems.forEach((otherItem) => {
                if (otherItem !== clickedItem) {
                    otherItem.parentNode.classList.remove('open');
                    otherItem.setAttribute('aria-expanded', 'false');

                    const otherMegaMenuWrapper = otherItem.parentNode.querySelector('.megaMenuWrapper');

                    if (otherMegaMenuWrapper) {
                        otherMegaMenuWrapper.setAttribute('aria-hidden', 'true');
                    }
                }
            });

            clickedItem.parentNode.classList.toggle('open');

            // toggle aria-hidden="true" on each .megaMenuWrapper div that is a sibling of clickedItem

            if (megaMenuWrapper) {

                if (clickedItem.parentNode.classList.contains('open')) {
                    megaMenuWrapper.setAttribute('aria-hidden', 'false');
                    clickedItem.setAttribute('aria-expanded', 'true');

                    // focus on first link in mega menu
                    const firstLink = megaMenuWrapper.querySelector('a');
                    if (firstLink) {
                        firstLink.focus();
                    }
                } else {
                    megaMenuWrapper.setAttribute('aria-hidden', 'true');
                    clickedItem.setAttribute('aria-expanded', 'false');
                }
            }

        });
    });

    // click anywhere outside of menu to close menu
    document.addEventListener('click', (event) => {
        const target = event.target;
        const isClickInside = container.contains(target);
        if (!isClickInside) {
            menuItems.forEach((item) => {
                item.parentNode.classList.remove('open');

                // add aria-hidden="true" to each .megaMenuWrapper div that is a sibling of item
                const megaMenuWrapper = item.parentNode.querySelector('.megaMenuWrapper');
                if (megaMenuWrapper) {
                    megaMenuWrapper.setAttribute('aria-hidden', 'true');
                    item.setAttribute('aria-expanded', 'false');
                }
            });
        }
    });

    // press escape key to close menu
    document.addEventListener('keyup', (event) => {
        if (event.key === 'Escape') {
            menuItems.forEach((item) => {
                item.parentNode.classList.remove('open');

                // add aria-hidden="true" to each .megaMenuWrapper div that is a sibling of item
                const megaMenuWrapper = item.parentNode.querySelector('.megaMenuWrapper');
                if (megaMenuWrapper) {
                    megaMenuWrapper.setAttribute('aria-hidden', 'true');
                    item.setAttribute('aria-expanded', 'false');
                }
            });
        }
    });

};

const init = () => {
    headerPin();
    mainNav();
};

export default init;
